<div *ngIf="product$ | async as product"
      class="container mb-pdp-tab-content mb-extended-validation-tab"
      data-cy="mb-extended-validation-tab">

  <div class="mb-pdp-tab-wrapper mb-extval-wrapper mb-extval-tab"
       *ngIf="extendedValidation$ | async as extendedValidation">
    <div class="col-12 p-0 mb-extval-headline">
      {{'mbProductTabs.extendedValidationFor' | mbTranslate}} <strong [innerHTML]="productName | safeHtml"></strong>
    </div>

    <!------------ Specificity ------------------>
    <ng-container *ngIf="extendedValidation.specificityEntries">
      <div class="mb-extended-validation-tab-wrapper row no-gutters">
        <div class="col-12 mb-extval-headline mb-extval-sub-headline mb-1"> {{'mbProductTabs.extendedValidationSpecificity' | mbTranslate}}</div>
        <ng-container *ngFor="let specificityEntry of specificityGroup; index as i">

          <!-------------- HTML Text data -------------------->
          <ng-container *ngIf="specificityEntry.type === mbDatasetEntryTypes.HTML_TEXT">
            <ng-container *ngFor="let specificityHTMLEntry of specificityEntry.value">
              <div class="col-12 mb-extval-specificity-description"  [attr.data-cy]="'mb-extval-specificity-description-' + i" [innerHTML]="specificityHTMLEntry.text | safeHtml"></div>
            </ng-container>
          </ng-container>

          <!------------- Table Entry data ------------------->
          <ng-container *ngIf="specificityEntry.type === mbDatasetEntryTypes.TABLE">
            <ng-container *ngFor="let specificityTableEntry of specificityEntry.value; index as tableRowIndex">
              <div [ngClass]="[tableRowIndex === 0 ? 'mb-extval-table-header' : '',
                               tableRowIndex % 2 === 0 ? 'even' : '',
                               'col-10 mb-extval-table-entry']"
                   [attr.data-cy]="'mb-extval-detailed-info-table-entry-'+ i">
                <div class="row no-gutters">
                  <div class="col col-sm-4 mb-extval-table-key" data-cy="mb-extval-detailed-info-table-key" [innerHTML]="specificityTableEntry.header | safeHtml"></div>
                  <div class="col col-sm-8 mb-extval-table-value" data-cy="mb-extval-detailed-info-table-value" [innerHTML]="specificityTableEntry.value | safeHtml"></div>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <!----------------- Text data ---------------------->
          <ng-container *ngIf="specificityEntry.type === mbDatasetEntryTypes.TEXT">
            <ng-container *ngFor="let specificityTextEntry of specificityEntry.value">
              <div class="mb-extval-table-legend col-10"
                   [attr.data-cy]="'mb-extval-specificity-info-text-entry-' + i">
                {{specificityTextEntry.value}}
              </div>
            </ng-container>
          </ng-container>

          <!---------------- Image data ---------------------->
          <ng-container *ngIf="specificityEntry.type === mbDatasetEntryTypes.IMAGE">
            <ng-container *ngFor="let specificityImageEntry of specificityEntry.value">
              <div class="col-md-4 col-sm-12 pr-3 d-grid">
                <div  class=" align-self-start image-header"
                      *ngIf="specificityImageEntry.headline"
                      [attr.data-cy]="'mb-sensitivity-image-header-' + i"
                      [innerHTML]="specificityImageEntry.headline | safeHtml"></div>
                <div class=" align-self-end cursor-pointer mb-detailed-info-image"
                     (click)="openGalleryDialog(specificityImageEntry, specificityEntry.value, specificityGroup[i+1].value)">
                  <img [src]="specificityImageEntry?.url"
                       class="img-responsive"
                       title="Extended-Validation detailed information image"
                       alt="Extended-Validation detailed information image"
                       [attr.data-cy]="'mb-detailed-information-image-' + i"/>
                  <div *ngIf="specificityImageEntry?.description"  [attr.data-cy]="'mb-detailed-information-image-description-' + i" class="mt-1 mb-detailed-info-image-description" [innerHTML]="specificityImageEntry?.description | safeHtml"></div>
                </div>
              </div>
            </ng-container>
          </ng-container>

        </ng-container>

      </div>
    </ng-container>

    <!------------ Sensitivity ------------------>
    <ng-container *ngIf="extendedValidation.sensitivityEntries">
      <div class="mb-extended-validation-tab-wrapper row no-gutters">
        <div class="col-12 mb-extval-headline mb-1"> {{'mbProductTabs.extendedValidationSensitivity' | mbTranslate}}</div>
        <ng-container *ngFor="let sensitivityEntry of sensitivityGroup; index as i">

          <!-------------- HTML Text data -------------------->
          <ng-container *ngIf="sensitivityEntry.type === mbDatasetEntryTypes.HTML_TEXT">
            <ng-container *ngFor="let sensitivityHTMLEntry of sensitivityEntry.value">
              <div class="col-12 mb-extval-specificity-description"  [attr.data-cy]="'mb-extval-specificity-description-' + i" [innerHTML]="sensitivityHTMLEntry.text | safeHtml"></div>
            </ng-container>
          </ng-container>

          <!------------- Table Entry data ------------------->
          <ng-container *ngIf="sensitivityEntry.type === mbDatasetEntryTypes.TABLE">
            <ng-container *ngFor="let sensitivityTableEntry of sensitivityEntry.value; index as tableRowIndex">
              <div [ngClass]="[tableRowIndex === 0 ? 'mb-extval-table-header' : '',
                               tableRowIndex % 2 === 0 ? 'even' : '',
                               'col-10 mb-extval-table-entry']"
                   [attr.data-cy]="'mb-extval-detailed-info-table-entry-'+ i">
                <div class="row no-gutters">
                  <div class="col col-sm-4 mb-extval-table-key" data-cy="mb-extval-detailed-info-table-key" [innerHTML]="sensitivityTableEntry.header | safeHtml"></div>
                  <div class="col col-sm-8 mb-extval-table-value" data-cy="mb-extval-detailed-info-table-value" [innerHTML]="sensitivityTableEntry.value | safeHtml"></div>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <!----------------- Text data ---------------------->
          <ng-container *ngIf="sensitivityEntry.type === mbDatasetEntryTypes.TEXT">
            <ng-container *ngFor="let sensitivityTextEntry of sensitivityEntry.value">
              <div class="mb-extval-table-legend col-10"
                   [attr.data-cy]="'mb-extval-sensitivity-text-entry-' + i">
                {{sensitivityTextEntry.value}}
              </div>
            </ng-container>
          </ng-container>

          <!---------------- Image data ---------------------->
          <ng-container *ngIf="sensitivityEntry.type === mbDatasetEntryTypes.IMAGE">
            <ng-container *ngFor="let sensitivityImageEntry of sensitivityEntry.value">
              <div class="col-md-4 col-sm-12 pr-3 d-grid">
                <div  class=" align-self-start image-header"
                      *ngIf="sensitivityImageEntry.headline"
                      [attr.data-cy]="'mb-sensitivity-image-header-' + i"
                      [innerHTML]="sensitivityImageEntry.headline | safeHtml"></div>
                <div class=" align-self-end cursor-pointer mb-detailed-info-image"
                     (click)="openGalleryDialog(sensitivityImageEntry, sensitivityEntry.value, sensitivityGroup[i+1].value)">
                  <img [src]="sensitivityImageEntry?.url"
                       class="img-responsive"
                       title="Extended-Validation detailed information image"
                       alt="Extended-Validation detailed information image"
                       [attr.data-cy]="'mb-detailed-information-image-' + i"/>
                  <div *ngIf="sensitivityImageEntry?.description" [attr.data-cy]="'mb-detailed-information-image-description-' + i" class="mt-1 mb-detailed-info-image-description" [innerHTML]="sensitivityImageEntry?.description | safeHtml"></div>
                </div>
              </div>
            </ng-container>
          </ng-container>

        </ng-container>
      </div>
    </ng-container>
  </div>

</div>
